'use client'
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import CommonNav from '../../commonNav'
const StatGraphs = dynamic(() => import('../../graphs'), { ssr: false })
import NoData from '../../noData'
import statsVector from '../../../../assets/images/error-images/stats.svg'
import dynamic from 'next/dynamic'

const MatchDetailLiveStats = ({ data, matchDetail, is100 }: any) => {
  const graphType = [
    {
      value: 'aWorm',
      navItem: 'Worm'
    },
    {
      value: 'aPartnership',
      navItem: 'Partnership'
    },
    {
      value: 'aRunTypes',
      navItem: 'Runs'
    },
    {
      value: 'aWickets',
      navItem: 'Wickets'
    },
    {
      value: 'aExtras',
      navItem: 'Extras'
    },
    {
      value: 'aRunRates',
      navItem: 'Run Rate'
    }
  ]

  function isDifferenceGreaterThan48Hours(date1: number, date2: number) {
    const diffInMilliseconds = (new Date(date2) as any) - (new Date(date1) as any)
    const diffInHours = diffInMilliseconds / (1000 * 60 * 60)
    return diffInHours > 48
  }
  const isGreaterThan48Hours = isDifferenceGreaterThan48Hours(
    matchDetail?.dStartDate,
    matchDetail?.dEndDate
  )

  if (!isGreaterThan48Hours) {
    graphType.unshift({
      value: 'aManhattan',
      navItem: 'Manhattan'
    })
  }

  const updatedArray = []
  for (let i = 0; i < graphType.length; i++) {
    const { value, navItem } = graphType[i]
    const hasValue = data?.liveStats?.some((obj: any) => obj[value].length > 0)

    if (hasValue) {
      updatedArray.push({ value, navItem })
    }
  }
  const filteredArray = updatedArray?.filter(item => item !== undefined)

  const finalArray = [
    ...filteredArray,
    { value: 'spider', navItem: 'Spider' },
    { value: 'wagonWheel', navItem: 'Wagon Wheel' },
    ...(matchDetail?.oFormat?.sValue !== 'test'
      ? [{ value: 'winPercentage', navItem: 'Win-Percentage' }]
      : [])
  ]

  const [activeTab, setActiveTab] = useState(finalArray[0]?.value)

  function activeTabHandler(e: any) {
    setActiveTab(e?.value)
  }

  return (
    <>
      {!(data?.liveStats?.length > 0) ? (
        <NoData imagePath={statsVector} />
      ) : (
        <section className="my-4 mb-8 ">
          <CommonNav
            items={finalArray}
            variant="pills"
            asButton
            className="my-3 justify-start"
            tabClassName="!text-base h-9 whitespace-nowrap"
            onTabChange={activeTabHandler}
            // activeTabClass='!font-bold'
            isActive={item => item?.value === activeTab}
          />
          <div className="md:!p-4 overflow-x-auto">
            <StatGraphs
              graphData={data?.liveStats}
              activeTab={activeTab}
              is100={is100}
              matchDetail={matchDetail}
              inningData={data?.inningData}
            />
          </div>
        </section>
      )}
    </>
  )
}

MatchDetailLiveStats.propTypes = {
  data: PropTypes.any,
  matchDetail: PropTypes.array,
  is100: PropTypes.bool
}

export default MatchDetailLiveStats
